var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPSarawak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid slice",
    id: "svgP",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1141936298916437,0,0,1.1141936298916437,-216.80005313504216,59.75788062059985)",
    style: {
      transform: "matrix(1.11419, 0, 0, 1.11419, -216.8, 59.7579)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "P192",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.3 489.7l-3.3 1.7-1.6-.6-3.7 3.2.4-4.5-13.6-.9-13.9-1.2 1.8-6.1-4.8-.9-2.8-5.5-8.2-5.5-6.3-3.6-7.3-2.7-1.8.2-2.2 4.4.4 6.2-1.2 8.2 3.7 3.7 11 8.2 5 7.4 2-.9-.8 1.7.8 3.7 4.1 2.4 9.5-.8 3.2 2.5 5 12.7 7.8 4.9 2.8-2.8 2.8-3.9.2-4.9 3.3.5 3.3-.5 3.8-3.3-.8-2.5 1.4-4.3.8-5.2.6-2.2.5-7.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "P193",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354 481.7l-7-8.1-11.3-1-4.5 2.1-3.3-2.5-7.4.8H295.4l-6.1 1.7-2.1-1.7-5.3-3.2-2.9-6.2-5.7-3.7-7-2.8-10.3-7-3.2-6.2 1.6-7-.8-1.2-.4-5.7v-7l-4.1 13.1-3.7 1.7-5.4 2v2.1l-1.6 5.3 5.3 14.4 13.6-.5-1.1 2.2 1.8-.2 7.3 2.7 6.3 3.6 8.2 5.5 2.8 5.5 4.8.9-1.8 6.1 13.9 1.2 13.6.9-.1.3 8-4.7 14.2 2.5-.2-2.2 3-.3 3.3 2.5v3.2h2.1l.9-2.4 3 .5.2 2.5-2.1 1.6 2.7 5.5 1.1-1.1 4.1-.5v-5.2l7.9-7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "P197",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.8 521.7l-.3 3.8s-1.1.8-2.7 1.4c-1.6.5-4.9 2.7-4.9 2.7l-2.5 2.5-4.1-4.1-.8-4.1-2.5-2.5 4.1-6-12-6.3-1.6.3-.3 3.6h-5.8l.9-4.9v-6.3l7.4-.8 3.6-3.6 4.1-.5v-5.2l7.9-6.9 3.4 1.4 8.2-.5 6.8 3.6-1.1 5.7-1.9 5.2.3 3.8-10.4 6.8-3.8 2.7 7.9 7.7.1.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "P194",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.3 487.6l-3.3-2.5-3 .3.2 2.2-14.2-2.5-8 4.7-.3 4.2 3.7-3.2 1.6.6 3.3-1.7 1.9.9 2.5-2 7.4 6.1 1 .8 2.5-3.3 1.8.9 2.9-4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M330.3 461.1v27.5"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "P198",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M331.1 550.6l5.7-2.5 8.6-5.7 2.5-5.3.4-5.7 1.6-3.3 1.6 2.1 2 5.7 6.2 2.9 7-.4 8.6-3.3 2.5-5.7-7.1-7.5-.3 3.8s-1.1.8-2.7 1.4c-1.6.5-4.9 2.7-4.9 2.7l-2.5 2.5-4.1-4.1-.8-4.1-2.5-2.5 4.1-6-12-6.3-1.6.3-.3 3.6h-15l2.5-8.5-7.6-5.8-.3-.2-.5 2.2-.8 5.2-1.4 4.4.8 2.5-3.8 3.3-3.3.5-3.3-.5-.3 4.9-2.7 3.8-2.9 2.9-3.3 7.8 4.1-.8 4.5 1.2 7-.4 4.5 5.7 4.5 5.3 1.2 3.3 2.2 5.1-.2-.5.2.5 1.9-4.5z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "P199",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.1 552.7l.4-5.8-4.5-5.3-.4-4.1-17.2 7.8-8.8-8-.5-.4-4.7-3.1-.3-.3-.4-.3-.6-.8-3.2-3.1-2.4 5.7-8.7 3.3-6.9.4-6.2-2.9-2-5.7-1.7-2.1-1.6 3.3-.4 5.8-2.5 5.3-8.6 5.7-5.8 2.5-1.9 4.3 2.3 5.5 8.3.5 5.3 1.2 2.9 4.9 2.8 4.1 10.7 4.5 6.6 3.3 4.5-2 3.7-5 2.8 3.3 4.1 1.3 3.3-4.6h4.1l3.3-4.9 3.3 4.5 1.6-.8.5-5.3 6.5-1.3 2.9-6.5 6.1-1.3z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "P200",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.5 494.9l-1.9 5.2.3 3.8-10.4 6.8-3.8 2.7 7.9 7.7 5.7 5.5 4.8 5.7 1.1 1.1 3.4 2.2 1.5 1.2.2.2.2.2 9.5 7.4 16.6-7.3 3.7-2.9v-3.7l.4-4.1-1.8-2.3v-.1l-.7-.9-.4-2-.3-.9v-.9l-.1-.8.1-1.5v-.9l-5.2 1.6-4.9 1.4s-.5-2.7-.5-4.4c0-1.6-6.3-6-6.3-6l-5.7-3.3-2.2-7.1.8-4.1-.8-5.3-4.9 1.2-5.2-1.4-1.1 6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.5 494.9l-1.9 5.2.3 3.8-10.4 6.8-3.8 2.7 7.9 7.7 5.7 5.5 4.8 5.7 1.1 1.1 3.4 2.2 1.5 1.2.2.2.2.2 9.5 7.4 16.6-7.3 3.7-2.9v-3.7l.4-4.1-1.8-2.3v-.1l-.7-.9-.4-2-.3-.9v-.9l-.1-.8.1-1.5v-.9l-5.2 1.6-4.9 1.4s-.5-2.7-.5-4.4c0-1.6-6.3-6-6.3-6l-5.7-3.3-2.2-7.1.8-4.1-.8-5.3-4.9 1.2-5.2-1.4-1.1 6z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "P196",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.8 495.5l-1.9-1.7-3.3-1.6-2.5 3.3-1-.8-7.4-6.1-2.5 2-.5 7.1.5-7.1-.5 7.9.3.2 7.6 5.8-2.5 8.5h9.3l.9-4.9v-6.3l7.3-.8 2.5-2.5-2.7-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M281.3 517.5l45.8-20.6"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "P195",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.3 488.9l-3-.5-.9 2.4h-2.1v-2l-2.9 4.3 1.5.7 1.9 1.7 3.6-2.5 2.1-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M366.8 468.3l-21.6 22.4"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "P201",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M451.4 475.1l-9.4-3.3-6.7-4.8 2.6 5.5-4.4 1.6-8.8 2.2-3.8 12 4.4 9.8 5.5 6.6 4.4 1.6s2.7 2.7 5.5 3.8c2.7 1.1 1.1 3.3 1.1 3.3l-7.1-3.8-7.7-2.7-6-8.2-6-6-2.2 2.7s-16.4-7.1-18.1-7.1c-.7 0-2.8.4-4.9.9l.8 5.3-.8 4.1 2.2 7.1 5.7 3.3s6.3 4.4 6.3 6c0 1.6.5 4.4.5 4.4l4.9-1.4 5.2-1.6v.9l.3-3 3.3.8h3.3l7-.4 12.3 5.7 14.8.8-.4-16.8 10.3 3.3 8.5 1.5-.7-.3-5.3-1.6.8-5.7 1.2-2s1.6-2.9 2-4.1c.4-1.2-3.3-1.6-3.3-1.6l-9-1.2-5.3-2 9.4-4.1 9.8-3.3-5.3-5.7-16.9-2.5z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "P202",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M500.6 550.2l-2.9-5.3-2.5-1.6s-5.3-3.3-8.6-6.1c-3.3-2.9-2.5-6.6-2.5-6.6l-2.5-4.1-2.9-3.7c-1.6-2.1 1.6-8.6 1.6-8.6l-5.6-4.1-1.1-.5-8.5-1.5-10.3-3.3.4 16.8-14.8-.8-12.3-5.7-7 .4h-3.3l-3.3-.8-.3 3v2.3l.3 1.8 1 2.8 1.8 2.4-.4 4.1v3.7l-3.7 2.9.4 4.1 2.1 2 2.5 3.3-.4 5.7-2.5 3.3-.4.9 7.8-.9 14.8-2.5 11.5-4.1 12.3 5.3 8.6 4.5 9-3.7 5.3 2.9 1.6 6.2 2.9 1.6.8-4.1 3.3.4 2.5-4.5 6.2-3.7 2.9-.4-1.2-.8-2.6-3z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "P203",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M560.1 503.4h-9l-4.9-8.2-.4-6.6-5.7 1.2-1.3-.2-1.2.2-11.9-2.1-4.9-.8h-2.9l-7.4 13.1-2.9 1.6-2.9-.4-.8 2.1-2.5 7.4-7.4-.4-3.3 7-2.5.8-5.3-3.3-2.5-.8s-3.3 6.6-1.6 8.6l2.9 3.7 2.5 4.1s-.8 3.7 2.5 6.6c3.3 2.9 8.6 6.1 8.6 6.1l2.5 1.6 2.9 5.3 2.9 2.9 1.2.8 4.5 4.1 9.8-.4 7.4 2.1 3.3-8.2 3.7-1.6 4.1-4.5 9-1.6 14.4-.8 2.5-8.6 5.3-13.5 3.3-8.2-2.5-7-6.6-2.5-2.9.4z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "P204",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M511.7 478.4l-7 3.3-5.3-2.5-.8-2.5-1.2 2.5-4.5.4-4.9-3.3-3.3-1.6-6.2 5.7-4.9 2.9-9.8 3.3-9.4 4.1 5.3 2 9 1.2s3.7.4 3.3 1.6c-.4 1.2-2 4.1-2 4.1l-1.2 2-.8 5.7 5.3 1.6.7.3.6.1.5.4 2.7 1.2 2.9 2.9 2.5.8 5.3 3.3 2.5-.8 3.3-7 7.4.4 2.5-7.4.8-2.1 2.9.4 2.9-1.6 7.4-13.1-5.7-6.6-.8-1.7z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "P205",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M498.1 466.9l-9.4-6.6-4.9-8.6-2.5-2.9-5.3 2.5 1.2-7.4-4.1-2-.4-2.9-5.3-2.1-8.8-2.1-2.2-1.1-1.1-3.3-2.2 1.6-7.6-3.3-3.9 12.1-7.1 19.7-2.7 4.3 2.2-.5 1.2 2.7 6.7 4.8 9.5 3.3 16.8 2.5 5.3 5.7 4.9-2.9 6.2-5.7 3.3 1.6 4.9 3.3 4.5-.4 1.2-2.5.9 2.5z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "P206",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M492.8 396.9c-2.1 0-7.6 1.4-9.7-2.1-2.1-3.5-11.1-18.7-10.4-25.7.7-6.9-2.8-6.9-2.8-6.9l1.4-11.5-.6.4-.5-5.5.5-3.3-1.6 1.6-6-7.1-4.9 5.5v8.2l1.6 25.2 1.1 8.2-7.1-4.4-4.9 1.1L446 397l-.5 8.2 2.2 1.1-6 6.6 2.7 5.5 4.9-1.1h5.5l7.1 2.7 2.2 2.2h-4.9l-7.1-3.3-2.7 4.9-2.7-1.1-1.1 6 7.7 3.3 2.2-1.6 1.1 3.3 2.2 1.1 8.8 2.2 5.3 2 4.9-.8-.4-2.5v-2.8l1.6-7 1.2-4.1-2.5-7h2.1l3.7 2.9 4.5-1.2 1.6-1.6-2.1-2.9-1.2-1.2 7.4-4.1 4.9-4.5c-.1-.1-3.8-5.3-5.8-5.3z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "P207",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M516.6 368l-1.2-3.7 3.7-14 .8-4.1-4-18.5-13.7 1.6-5.1 3.3-7.9 5.8-13.7 9.3-4.3 2.9-1.4 11.5s3.5 0 2.8 6.9c-.7 6.9 8.3 22.2 10.4 25.7 2.1 3.5 7.6 2.1 9.7 2.1 2.1 0 5.8 5.2 5.8 5.2l1.2.8 4.5-2.9-1.2-3.7 4.9-8.2 8.6-10.3 2.9-4.9-.4-2.5-2.4-2.3z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "P208",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M498.5 402.1l-4.9 4.5-7.4 4.1 1.3 1.2 2 2.9-1.6 1.6-4.5 1.3-3.7-2.9h-2.1l2.5 7-2.9 11 3.3-.4 4.1-1.2 4.5-.4 4.5-4.1 1.3 2-1.3 3.3 6.6 3.3.8 2.9 15.6-6.2 3.3-3.7-1.3-5.2-.1-2.6-.3-.8v-2.9l-.8-2.4-3.1-2.2-3-2.8-3.8-5.7-3.2-3.7-4.5 2.9z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "P209",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M568.3 467.3l-2.9-1.6-6.5-1.3-5.4-4.5-4.5-3.7 1.2-4.9-4.5-7-5.3-1.6.8-14.8-1-1-.2.2-1.2-1.6-11.9.8-4.1 3.3-2.9-1.3-3.3 3.7-15.6 6.2-.8-2.9-6.6-3.3 1.3-3.3-1.3-2-4.5 4.1-3.3.4-5.3 1.2-3.3.4v1.7l.4 3.7-4.9.8.4 2.9 4.1 2-1.2 7.4 5.3-2.5 2.5 2.9 4.9 8.6 9.4 6.6 1.3 12.3 5.3 2.5 7-3.3.4 2 5.7 6.6h5.8l7.4 1.6 7.7 1.1 7-1.1 5.8-2 1.6-3.7 10.7-2.1 2.4-8.2 1.3-.8z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "P210",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M588.8 415.2l-5.3-1.6h-4.9l-4.9.8s-11.9-2.9-14-4.1l-2.1 2.9-3.3 3.3-2.9 7.8-3.3.4-4.5-.8-3.5 3.1 1 1-.8 14.8 5.3 1.6 4.5 7-1.2 4.9 4.5 3.7 5.3 4.5 6.6 1.2 2.9 1.6-.8 4.5-1.2.8 4.5.8 3.3 1.6 4.5-2.5 5.3-5.7 4.1-.8 7.8-1.2 3.7-4.9-7.4-7-1.6-1.2 1.2-.4 3.7.4 5.7-3.7 2.9-9.4-8.2-3.3-2.9-7 2.9-1.6.4-7.8-.3-2.7-2.6.3-4.4-1.3z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "P211",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M554.3 406.2l-2.9-2.9-3.5-3.5-3.5-.6-5.7 5.7-10.7-7.4h-2l-2.1 3.3-2.1.4 2.2 6.5.5 1.1-1.8 3.1-3.3 1.2-2.1 1.2.8 2.5.2 4.2 1.4 7.3 2.9 1.2 4.1-3.3 11.9-.8 1.4 1.4 3.5-3.1 4.5.8 3.3-.4 2.9-7.8 3.3-3.3 2.1-2.9c-2.1-1.2-.8-2.5-.8-2.5v-1.2l-4.5-.2z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "P213",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M634.4 302.9l1.2 7.2-.4 7.3-2.9 8.5-33.6-3-4.5 11.9-6.2 14.7-.4 14-4.5 1.2-9.5 12.3-3.7-2.8-.4-4.1-26.2-2.1-1.7-1.2-1.2-6.6-2.9-5.3-3.7-1.3-4.9-1.2-9-6.1-4.1-18.8 30.9-3.8z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "P214",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M738.8 343.2h-6l-2-2-5.2 2.8-13.3 4-2.4-1.6-4-.4-6.5-2 2-4 2-5.6V332l-5.2-4-7.7-1.2-1.6-3.6-4.4-1.2-8.1-2.4h-3.6l-4-.4-3.6 2.8-4.4.8 2.4-3.6-2-1.2-.4-6-6.5 3.2-3.5 3.1-6.2.8-2.3-9.4-2.3-.5-4.1 7.8-3.3 9-33.7-3-4.5 11.9-6.2 14.8-.4 13.9-4.5 1.2-9.4 12.3-3.7-2.9-.4-4.1-26.3-2.1-1.6-1.2-6.2 4.9s-.9.7-1 1.7l.2 1 5.2 8.5 1.9 3 1.9 3 7.4 3.3 7.4 2 5.3 4.1.4 1.6-2.9 2.1-1.2 4.5-1.2 1.2.8 2.5c2.1 1.2 14 4.1 14 4.1l4.9-.8h4.9l5.3 1.6 4.5 1.2 2.6-.3 7.7-2.7h9.8l3.8-2.2 8.2 1.6 5.5 1.1 5.5 1.6 6.6.5 3.3.5 2.7-3.3 2.7.5 4.4-6V403l3.1-4.5 7.5.2 4.7-6.6-.5-8.8 7.1-6 4.4 1.1 14.8-8.8 4.4-1.1 4.9-2.2 8.3-1.2 2.5-1.2.4-1.2 2.5.8 1.6.8 3.4-1.4 2 2 .4 4.4 2-2.8 1.6-2.8 5.7-4 6.5-4.8 4.4 2 .4-6.1s1.6-2.4 4.4-4c2.8-1.6.4-2.4.4-2.4l-5.2-.4-3.5-2.3-2.1 1.1-3.6.4z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "P212",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M511.3 409.4l6.2 4.9 2.1-1.2 3.3-1.2 1.6-3.3-.3-.9-.5-1.1-1.6-5.3 2.1-.4 2.1-3.3h2.1l10.7 7.4 5.7-5.7 3.3.4.2.2 6.4 6.4 5.7.4 1.2-4.5 2.9-2.1-.4-1.6-5.3-4.1-6.6-1.6-8.2-3.7-1.9-3-1.8-2.7-.2-.3-5.2-8.3c-.2-.4-.3-.8-.2-1.2l-.2-.9 7.4-5.7-1.2-6.6-2.9-5.3-3.7-1.2-4.9-1.2-9-6.2-.8 4.1-3.7 14 1.2 3.7 2.5 2.5.4 2.5-2.9 4.9-8.6 10.3-4.9 8.2 1.2 3.7 2.9 3.3 3.8 5.7z",
    id: "P212"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "P215",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M659.4 482.8l-4.9-6.1-3.2-2 5.7-3.6 3.6-.5V467l2.8-2-3.2-.8 8.3-3.2 6.1.5 2.8-4 5.4-1.9 14.6-2.5-7.5-14.8-1.7-3.7 3.8-4.3-3.8-6.7.1-6.8-.5-1.9 16.3-.3 2.5-3.6-2.1-3.3-2.9-3.4 1.8-2.1 1.2-3.2-2.3-4.3-6.6.5-4.4 5.6-10.8 4.2-4.7-2.3-4-2.3-4.4-1.9-8.2.2-3.1 4.3v4.9l-4.4 6.1-2.7-.6-2.7 3.3-3.3-.5-6.6-.6-5.5-1.6-5.4-1.1-8.2-1.7-3.9 2.2h-9.8l-7.7 2.8.3 2.7-.4 7.8-2.9 1.6 2.9 7 8.2 3.3-2.9 9.4-5.7 3.7-3.7-.4-1.2.4 1.6 1.2 7.4 7-3.7 4.9-7.8 1.3-4.1.8-5.3 5.7-4.6 2.5-3.2-1.6-4.6-.9-2.4 8.2-10.7 2.1-1.6 3.7-5.8 2 .4 6.6 5 8.2h9l2.9-.4 6.5 2.5L581 501l16.4-5.8 5.8-5.7 12.7-.9 12.3 2.1 5.8-1.2 9.8 3.2 4.1-.4 8.2-5.7 3.3-1.4z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "P216",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M925.8 337.9l-5.5 7.1-9.8 5.5-8.8-3.3h-14.2l-6.6-4.9-3.8-8.8-3.3-3.3-4.9-4.9-8.8-1.6-4.4-7.7-9.3-3.8-2.2-5.5-4.4-4.9-8.8-4.9v-7.7l6-1.1-1.1-4.4-7.7-4.4-9.8-10.9-3.3-2.2-6.6 4.9-4.9.5-4.9 1.1 1.5-8.1-2.3-4.2-5.6.2-2.3-5.4-13.1 8.7-4.4 14.2-11.1-4.4-15 8.2-.7 7.3 17.1 5.6 3.7 16.1-17 29.5-2.2-2.2-3.3 3.3 3.5 2.3 5.2.4s2.4.8-.4 2.4c-2.8 1.6-4.4 4-4.4 4l-.4 6.1-4.4-2-6.5 4.8-5.7 4-1.6 2.8-2 2.8-.4-4.4-2-2-3.1 1-4.1-1.6-.6 1.2-2.2 1.4-8.9 1.4-4.4 1.9-4.2 1.4-15.1 8.7-4.4-1.2-7.3 6.2.5 8.7-1.7 2.2-.6 1.9-1.9 2.7 9.1 3.6 4.8 2.3 10.6-3.9 4.1-5.9 6.7-.8 2.2 4.8-.9 2.7-2.2 2.5 3.1 3.5 2 3.2-2.4 3.6-5.6.4H688l.4 2.4-.4 6 4.1 6.9-3.6 4.6 8.8 18.3-14.4 2.5-5.4 2-2.8 3.9-6-.6-8.5 3.3 3.2.8-2.8 2v3.6l-3.6.4-5.6 3.6 3.2 2 4.8 6v2.4l-3.3 1.4 14 2 6.2 4.5-9.4 12.3.8 3.7 15.2-3.3 8.2 5.3 6.6-1.2 8.2 2.9 4.9.4 4.9 6.6 7.8 4.9 4.1-2.1 7.8-2.5 5.7 2.9 8.2 9.4 5.3-4.1 9-3.7 7.8-4.5-.4-5.7 4.1-3.7 9-3.3 10.3-3.3 16.8-2.1 9 6.6 4.5-4.9 11.9-1.2 7.4-7.8 6.6 4.5 5.7 1.6 7.4 4.9 6.2-8.6.4-5.7 2.5-4.5 7.8-13.1 1.6-10.3-.8-6.2 4.5-7 5.3 1.2 8.6-5.7.8-9.8.4-7.8-7.4 2.9v-11.1l-3.3-4.9 5.3-13.5h11.5l5.7-3.3-1.6-3.3 1.2-6.1 6.2 2.1 6.2-7 3.3-.4 6.2-7.4 11.1-2.5 2.5-5.3-4.5-2.1-2.5-4.9-4.1-2.9-2.9 2.5-7.8-4.5 4.1-6.2 3.3-11.1-2.9-6.6-4.2-.3-.6 6.1z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "P218",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M786.5 158c-1.4.9-4 .3-5.6-.2l-8.8 12.7-18.6 21.3-7.7 7.1-.2.2 9.3 10.5s-2.8 5.4 1.3 7.6c0 0 2.9-2.5 4.8-3.2 1.9-.6 5.7-.3 7-.6 1.3-.3 4.4-.6 4.4-.6l3.2 1.3 3.8-1 1.6-1.6s3.6 3.6 9.9 4.7l-.1-.3 5.5-5.5-.5-13.1-3.8-19.7.5-9.9.5-7.1c-2.1-1.5-5.2-3.5-6.5-2.6z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "P220",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M893.7 164.1l-11.6 15.7-9.8 2.7-2.7-3.3-4.9-2.7-4.4-6-4.9-4.4-7.7-14.2-3.3 2.2-4.9-1.6-6.6 2.2-.5-8.8-2.2-10.4-8.2-13.7-4.9-.5-5.5-5.5 1.1 1.1.6.5-.6 1.6v6l2.7 4.4 3.8 5.5c1.6 3.3-2.2 7.1-2.2 7.1l-6 4.4-8.2 6 1.1 3.8-4.4 2.7-6.6 1.6-.5 7.1-.5 9.9 3.8 19.7.5 13.1-5.5 5.5 2.2 6-1.6 6 1.6 2.7-2.2 2.2-4.4 8.2 7.1 8.8-3.8 5.5 2.7 6 5.5-.6 2.7 4.4-.5 1.1-1.1 6.6 4.9-1.1 4.9-.5 6.6-4.9 3.3 2.2 9.8 10.9 7.7 4.4 1.1 4.4-6 1.1v7.7l8.8 4.9 4.4 4.9 2.2 5.5 9.3 3.8 4.4 7.7 8.8 1.6 4.9 4.9 3.3 3.3 3.8 8.8 6.6 4.9h14.2l8.8 3.3 9.8-5.5 5.5-7.1.5-5.5 4.2.3 6.2-7 1.2-5.7 6.2-4.1 5.7-4.5 3.3-6.2 3.3 1.2 3.3 7 9-2.5 2.1-4.1 7-.4 3.3-2.5.8-8.2 5.7-7.4-4.9-3.7-.4-9 3.3-11.9 2-5.8 3.3-4.4 3.7 5.9 2.3-3.3-.5-4.8-5.2-10.1-2.9-18 4.9-22.5-5.4-5.6-6.1-.7-1.9 7.3-2.6 2.3-2.6-.9-3.5.5-5.4 3-2.8 4-2.3.1-12.3-6.7.2-6.8-8.2-9-5.7-7.8-7.4-10.3-9.8-.8-2.9.8-4.5-1.6-8.2-1.6-8.3-2.8"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "P219",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M819.1 134.9l-3.8-5.5-2.7-4.4v-6l.6-1.6-.6-.5-1.1-1.1-9.3-2.2-9.8-2.2-3.8 3.3 3.3 8.8-.5 12.6-4.4 13.1-6 8.6c1.6.5 4.2 1.1 5.6.2 1.3-.9 4.4 1.1 6.5 2.6l6.5-1.6 4.4-2.7-1.1-3.8 8.2-6 6-4.4c-.1 0 3.7-3.9 2-7.2z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "P221",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M963.5 210.1c1.4-3.5 8.3-8.3 12.5-6.2 4 2 5.6-9.7 5.6-9.7s-4.1-6.5-2.1-14.6c2.3-9 .7-16.7-8.3-16.7-8.4 0-13.9-11.8-13.9-11.8v-3.3l-4.1-4.6-4.9.5-2.2-3.8-12-2.7h-3.8l-2.2-17-7.1-20.8 1.1-13.1 3.3-8.2-7.1-3.8-1.6 1.6-5.5 6.6-12 2.2-2.7 5.5-6.6 4.4 3.3 14.8 2.2 20.2 7.7 3.8-3.3 12-4.9 8.2 3.8-1.1-4.2 9.5-.6 2.1 8.2 2.9 8.2 1.6 4.5 1.6 2.9-.8 9.8.8 7.4 10.3 5.7 7.8 8.2 9-.4 6.6c-.1 0 13.7 9.7 15.1 6.2z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "P222",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M981.6 194.1s-4.1-6.5-2.1-14.6c2.3-9 .7-16.7-8.3-16.7-8.4 0-13.9-11.8-13.9-11.8v-3.3l.3.3 4.9-4.4-6-7.7-4.9-8.8-1.1-7.1 1.1-6.6 1.1-4.9-3.1-3.3-1.6-9.8-1.2-9-11.9-11.9-.4-3.3 5.7-2.9V66h4.9l2.5 4.9 9.8 2.9 5.7-4.1 6.2-6.2 4.9-.4 2.5 1.6L989 61l3.7.4 1.2 2.9 3.7 16.4.8 7.4-6.6 11.9-6.6 9 2 9 .8 2.9-1.2 4.9 3.7 6.2v7.4l6.6 2.9 2.9 6.2-2.9 7 .4 14 4.1 1.6-6.2 20.5-6.2 1.2-1.6 2.5.3.1-6-1.2"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "P217",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M635.2 317.4l.4-7.3-1.2-7.3 8.1-2.2 29.5-12 4.4-9.3V276l10.9-8.2 6-9.9 11.5-9.3 1.6-6.6 13.7-17 1.1-8.2 19.1-13.1 3.3-2.6 1.9-2.1 9.3 10.5s-2.8 5.4 1.3 7.6c0 0 2.9-2.5 4.8-3.2 1.9-.6 5.7-.3 7-.6 1.3-.3 4.4-.6 4.4-.6l3.2 1.3 3.8-1 1.6-1.6s3.6 3.6 9.9 4.7l2.1 5.7-1.6 6 1.6 2.7-2.2 2.2-4.4 8.2 7.1 8.8-3.8 5.5.3.1-13.4 8.9-4 13.8-11-4.4-15 8.4-.7 7 17.1 5.6 3.7 16.4-17 29.5-2.2-2.2-3.3 3.3-2.1 1.1-3.2.4h-6l-2-2-5.2 2.8-13.3 4-2.4-1.6-4-.4-6.5-2 2-4 2-5.6v-2.4l-5.2-4-7.7-1.2-1.6-3.6-4.4-1.2-8.1-2.4h-3.6l-4-.4-3.6 2.8-4.4.8 2.4-3.6-2-1.2-.4-6-6.5 3.2-3.5 3.1-6.1.3-2.3-8.7-2.5-.6-4.2 7.7"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "matrix(1, 0, 0, 1, -35, 0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 253.2,
    y: 487.1
  }, "\n        P192\n      "), /*#__PURE__*/React.createElement("text", {
    x: 295,
    y: 484.5
  }, "\n        P193\n      "), /*#__PURE__*/React.createElement("text", {
    x: 346.8,
    y: 508.5
  }, "\n        P197\n      "), /*#__PURE__*/React.createElement("text", {
    x: 314,
    y: 456.9
  }, "\n        P194\n      "), /*#__PURE__*/React.createElement("text", {
    x: 318.4,
    y: 529.1
  }, "\n        P198\n      "), /*#__PURE__*/React.createElement("text", {
    x: 359,
    y: 557.6
  }, "\n        P199\n      "), /*#__PURE__*/React.createElement("text", {
    x: 375.2,
    y: 524.2
  }, "\n        P200\n      "), /*#__PURE__*/React.createElement("text", {
    x: 253.2,
    y: 525.6
  }, "\n        P196\n      "), /*#__PURE__*/React.createElement("text", {
    x: 354,
    y: 464.8
  }, "\n        P195\n      "), /*#__PURE__*/React.createElement("text", {
    x: 427.1,
    y: 499.1
  }, "\n        P201\n      "), /*#__PURE__*/React.createElement("text", {
    x: 439.9,
    y: 536
  }, "\n        P202\n      "), /*#__PURE__*/React.createElement("text", {
    x: 512.4,
    y: 518
  }, "\n        P203\n      "), /*#__PURE__*/React.createElement("text", {
    x: 478.5,
    y: 492.7
  }, "\n        P204\n      "), /*#__PURE__*/React.createElement("text", {
    x: 447.4,
    y: 455
  }, "\n        P205\n      "), /*#__PURE__*/React.createElement("text", {
    x: 450.6,
    y: 394.2
  }, "\n        P206\n      "), /*#__PURE__*/React.createElement("text", {
    x: 481.1,
    y: 361.6
  }, "\n        P207\n      "), /*#__PURE__*/React.createElement("text", {
    x: 489.2,
    y: 424.2
  }, "\n        P208\n      "), /*#__PURE__*/React.createElement("text", {
    x: 509.6,
    y: 455.8
  }, "\n        P209\n      "), /*#__PURE__*/React.createElement("text", {
    x: 560.7,
    y: 436.2
  }, "\n        P210\n      "), /*#__PURE__*/React.createElement("text", {
    x: 526,
    y: 418.6
  }, "\n        P211\n      "), /*#__PURE__*/React.createElement("text", {
    x: 553.7,
    y: 335.8
  }, "\n        P213\n      "), /*#__PURE__*/React.createElement("text", {
    x: 622.9,
    y: 365.8
  }, "\n        P214\n      "), /*#__PURE__*/React.createElement("text", {
    x: 514.4,
    y: 384.4
  }, "\n        P212\n      "), /*#__PURE__*/React.createElement("text", {
    x: 625,
    y: 440.2
  }, "\n        P215\n      "), /*#__PURE__*/React.createElement("text", {
    x: 789.8,
    y: 391.9
  }, "\n        P216\n      "), /*#__PURE__*/React.createElement("text", {
    x: 713.4,
    y: 272.6
  }, "\n        P217\n      "), /*#__PURE__*/React.createElement("text", {
    x: 762.7,
    y: 187
  }, "\n        P218\n      "), /*#__PURE__*/React.createElement("text", {
    x: 786.3,
    y: 132.8
  }, "\n        P219\n      "), /*#__PURE__*/React.createElement("text", {
    x: 873.7,
    y: 230.4
  }, "\n        P220\n      "), /*#__PURE__*/React.createElement("text", {
    x: 913.8,
    y: 151.1
  }, "\n        P221\n      "), /*#__PURE__*/React.createElement("text", {
    x: 962.8,
    y: 101
  }, "\n        P222\n    ")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPSarawak);
export default __webpack_public_path__ + "static/media/p_sarawak.f7c3216b.svg";
export { ForwardRef as ReactComponent };